import { useCallback } from 'react'

import { QuickStartStep } from '../enums/quickStartStep'
import { useQuickStartProgress } from './useQuickStartProgress'

export const useMarkPurchasesStepDone = () => {
  const { completionByStep, markStepDone } = useQuickStartProgress()

  return useCallback(() => {
    if (!completionByStep[QuickStartStep.Purchases]) {
      markStepDone(QuickStartStep.Purchases)
    }
  }, [completionByStep, markStepDone])
}
